import './types';

export const shapeThemeOptions = {
  borderRadius: 8,
  'borderRadius-l': 16,
};
